///<reference path="../../../../../typings/index.d.ts"/>
///<reference path="../short-cuts.helper.ts"/>

module Meevo.Components.ShortCuts {
    'use strict';

    interface IButtonShortCutLabelDirectiveAttrs {
        meevoBtnSc: keyof ICombinationNames;
        meevoBtnClass: string;
    }

    export class ButtonShortCutLabelDirective implements angular.IDirective {
        restrict = 'A';
        priority = -1;

        constructor(private $timeout: angular.ITimeoutService,
            private shortCutsHelper: IShortCutHelper) {
        }

        link(scope: angular.IScope, element: angular.IAugmentedJQuery, attrs: IButtonShortCutLabelDirectiveAttrs) {

            //timeout was used in order to grab boolean value of 'isDesktop' since there is a delay when you load a MaintForm such as clients

            this.$timeout(() => this.shortCutsHelper.addLabel(element, {
                additionalClass: attrs.meevoBtnClass,
                shortCutKey: attrs.meevoBtnSc,
                isDesktop: scope.$parent.isDesktop
            }), 100);
        }

        static factory(): angular.IDirectiveFactory {
            const directive = ($timeout: angular.ITimeoutService, shortCutsHelper: IShortCutHelper) => {
                return new ButtonShortCutLabelDirective($timeout, shortCutsHelper);
            };

            directive.$inject = ['$timeout','meevo.components.short-cuts.ShortCutsHelper'];

            return directive;
        }
    }

    angular.module('meevo.components.short-cuts')
        .directive('meevoBtnSc', ButtonShortCutLabelDirective.factory());
}
